/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layouts/layout.vue";
import BlankLayout from "@/layouts/BlankLayout";
import LayoutChild from "@/layouts/LayoutChild";
//
import zuzhijigouRoutes from "./modules/zuzhijigou";
import hangyeRoute from "./modules/hangye";
import newsRoutes from "./modules/newsRoutes";
// import meitiRoutes from "./modules/meitiRoutes";
import zhengwuRoutes from "./modules/zhengwu";
import dangjianRoutes from "./modules/dangjianRoute";
import lianzhengRoutes from "./modules/lianzhengRoute";
import hudongRoutes from "./modules/hudongRoute";
import trafficRoutes from "./modules/trafficRoutes";
// import travelServiceRoutes from "./modules/travelServiceRoutes";
import topicRoutes from "./modules/topicRoutes";
import searchRoutes from "./modules/search";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

// eslint-disable-next-line no-unused-vars
const RouteView = {
  name: "RouteView",
  functional: true,
  render(h, ctx) {
    return h("div", {
      class: ["layout-main main"]
    }, ctx.children);
  },
};

// const RouteView = {
//   name: "RouteView",
//   render: (h) => h("router-view"),
// };

export const routes = [{
  path: "/",
  name: "Home",
  meta: {
    title: "",
    hidden: true,
  },
  redirect: "/index",
  // redirect: "/news",
  component: Layout,
  children: [
    {
      path: "/index",
      name: "index",
      meta: {
        title: "首页",
        // hidden: true,
      },
      // component: () => import("@/views/index/index2.vue"),
      component: () => import("@/views/index/index3.vue"),
    },
    ...zuzhijigouRoutes,
    // hangyeRoute,
    ...newsRoutes,
    // 媒体专栏
    // ...meitiRoutes,
    // 政务
    ...zhengwuRoutes,
    // 党建
    // ...dangjianRoutes,
    // 廉政
    // ...lianzhengRoutes,
    // 出行服务
    ...trafficRoutes,
    // ...travelServiceRoutes,
    // 互动交流
    ...hudongRoutes,
    // 专题
    ...topicRoutes,
    ...searchRoutes,
  ],
},

{
  path: "*",
  name: "NoteFound",
  redirect: '/index',
  meta: {
    title: "NoteFound",
    hidden: true,
  },
},

  // this generates a separate chunk (about.[hash].js) for this route
  // component: () => import( /* webpackChunkName: "about" */ "@/views/demo/$msgbox"),

];
export const routesNav = routes[0].children

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log('[ to, from, savedPosition ] >', to, from, savedPosition)
    // if (savedPosition) {
    //   return savedPosition
    // }
    // return {
    //   x: 0,
    //   y: 0
    // }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 400)
    })
  }
});
router.beforeEach((to, from, next) => {
  // console.log("from", from);
  // console.log("to", to);
  if (from.path === "/" && to.name !== "news") {
    sessionStorage.setItem("isRouteIndex", "");
  }
  next();
});

export default router;